import { createAction } from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';
import { TimeZone } from 'app/modules/main/models/time-zone';

export type LoadPublisherTimeZoneAction = ActionCreator;

export class PublisherTimeZoneActions {

  /**
   * ${...} contains implementation details internal to this feature,
   * do not dispatch these from outside of this feature but instead
   * create a meaningful domain event describing what has happened to cause
   * the side effect and/or state change, and where the change originated from
   *
   * Domain events are configured using the following injection tokens:
   *
   *   @see PublisherTimeZoneActions.LOAD_TIME_ZONE
   **/
  static $ = class {

    static readonly loadingPublisherTimeZone =
      createAction(
        '[Publisher Timezone Feature] Loading Publisher Timezone',
      );

    static readonly publisherTimeZoneLoaded =
      createAction(
        '[Publisher Timezone Feature] Publisher Timezone Loaded',
        (timeZone: TimeZone) => ({ timeZone }),
      );

    static readonly publisherTimeZoneLoadFailed =
      createAction(
        '[Publisher Timezone Feature] Publisher Timezone Load Failed',
        (error?: string) => ({ error }),
      );
  };

}
